var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'gauge-indice total-' + _vm.total},_vm._l((_vm.total),function(c){return _c('span',{key:'gi_' + c,class:c <= _vm.value ? 'active' : ''})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }